import { EpiContent } from '@api/types';
import { ContentItemLoader } from '@components';
import { isValidElement } from 'react';

export type ContentItemListProps = {
  content?: EpiContent;
  component: React.FC<any>;
};

export const ContentItemList = ({ content, component }: ContentItemListProps) => {
  if (isValidElement(content)) {
    return content;
  }
  return (
    <>
      {content?.map((item) => {
        const guid = item?.contentLink?.guidValue;
        return <ContentItemLoader key={guid} guid={guid} component={component} />;
      })}
    </>
  );
};
